<template>
  <grid-layout
     :layout="widgets"
     :col-num="colnum"
     :vertical-compact="verticalCompact"
     :auto-size="autoSize"
     :row-height="rowheight"
     :is-draggable="editable"
     :is-resizable="editable"
     :margin="[0, 0]"
     :use-css-transforms="useCssTransform"
     @layout-updated="updateAllEvent" >
    <grid-item
       v-for="widget in widgets"
       :key="widget.id + '@' + widget.i"
       :x="widget.x"
       :y="widget.y"
       :w="widget.w"
       :h="widget.h"
       :i="widget.i"
       :is-resizable="widget.props.allowResize"
       :is-draggable="widget.props.allowDrag"
       :drag-allow-from="widget.props.dragAllowFrom" >
      <slot :widget="widget" ></slot>
    </grid-item>
  </grid-layout>
</template>

<script>
import VueGridLayout from 'vue-grid-layout'

export default {
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem
  },
  props: {
    widgets: {
      required: true,
      type: Array
    },
    mode: {
      required: true,
      type: String
    },
    verticalCompact: {
      type: Boolean,
      default: true
    },
    autoSize: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    colnum () {
      return this.$store.getters.getMacarons('colnum')
    },
    rowheight () {
      return this.$store.getters.getMacarons('rowheight')
    },
    useCssTransform () {
      return this.$store.getters.getMacarons('useCssTransform')
    },
    editable () {
      return this.mode === 'edit'
    }
  },
  methods: {
    updateAllEvent () {
      this.widgets.forEach(w => {
        this.$store.dispatch('updateWidget', w)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons/src/components/PortalGrid.vue